class CartIconBubble extends HTMLElement {
  #toggleButton = this.querySelector('[aria-controls="cart-drawer"]');
  #cartDrawer = document.querySelector('cart-drawer');

  connectedCallback() {
    if (!this.#toggleButton) return;
    this.#toggleButton.addEventListener('click', (event) => this.toggle(event));
  }

  toggle(event) {
    event.preventDefault();
    event.stopPropagation();

    if (window.rebuyOverwrite) {
      this.#toggleRebuySmartCart();
      return;
    }
    if (!this.#cartDrawer) return;

    this.#cartDrawer.body.classList.contains(this.#cartDrawer.activeClass)
      ? this.#cartDrawer.close()
      : this.#cartDrawer.open();
  }

  #toggleRebuySmartCart() {
    const smartCart = window.Rebuy?.SmartCart;
    if (!smartCart || smartCart.status !== 'ready') return;
    smartCart.visible ? smartCart.hide() : smartCart.show();
  }
}
customElements.define('cart-icon-bubble', CartIconBubble);
